
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return /^(6(456|755|780|922)|18(04|26|82)|84(|41)|7((32|58|65)6|574|703)|3(00[27]|317|390|994)|2237|2820|4399|9043|9783)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
